module.exports = __webpack_public_path__ + "static/media/stop.6f1e6565.svg";